import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TimeWorkedService {
  http: HttpClient;

  constructor(http: HttpClient) {
    this.http = http;
  }

  getCrewClockInStatus(pRPCKeyID, crewTemplateID) {
    let url = "/CrewTimecard/GetCrewClockInStatus?pRPCKeyID=" + pRPCKeyID + "&crewTemplateID=" + crewTemplateID;
    return this.http.get(url).toPromise();
  }

  getDailyTime(employee, pRPCKeyID, startDateString = null, endDateString = null) {
    let url = "/Timecard/GetDailyTime?employeeString=" + employee + "&pRPCKeyID=" + pRPCKeyID;
    if (startDateString != null)
      url += "&startDateString=" + startDateString;
    if (endDateString != null)
      url += "&endDateString=" + endDateString;
    return this.http.get(url).toPromise();
  }

  getTemplateDays(crewTemplateID) {
    let url = "/CrewTimecard/GetTemplateDays?crewTemplateID=" + crewTemplateID;
    return this.http.get(url).toPromise();
  }

  getWeeks(pRPCKeyID) {
    let url = "/Timecard/GetWeeksByPRPCKeyID?pRPCKeyID=" + pRPCKeyID;
    return this.http.get(url).toPromise();
  }

  insertUpdateTime(employee, pRPCKeyID, dateWorkedString, startTimeString, stopTimeString, seq, notes, breakHours) {
    let url = "/Timecard/InsertUpdateTime";
    return this.http.post(url, {
      employee: employee,
      pRPCKeyID: pRPCKeyID,
      dateWorkedString: dateWorkedString,
      startTimeString: startTimeString,
      stopTimeString: stopTimeString,
      seq: seq,
      notes: notes,
      breakHours: breakHours
    }).toPromise();
  }

  deleteTime(employee, pRPCKeyID, dateWorkedString, seq) {
    let url = "/Timecard/DeleteTime";
    return this.http.post(url, {
      employee: employee,
      pRPCKeyID: pRPCKeyID,
      dateWorkedString: dateWorkedString,
      seq: seq
    }).toPromise();
  }
}
